import './index.css';
import HeroSection from '../../components/landing/hero-section';
import Header from '../../components/landing/header';
import AboutUs from '../../components/landing/about-section';
import Features from '../../components/landing/features-section';
import ContactUs from '../../components/landing/contact';
import Footer from '../../components/landing/footer';
import Pricing from '../../components/landing/pricing';

function Landing() {

  return (
    <div className='app-wrapper'>
      <Header />
      <HeroSection />
      <AboutUs />
      <Features />
      <Pricing />
      <ContactUs />
      <Footer />
    </div>
  );
}

export default Landing;
